export default {
  // 短信验证码
  smsSend: { url: '/v1/sys/sms/send' },
  // 短信验证
  smsCheck: { url: '/v1/sys/sms/check' },
  // 修改密码
  updatePwd: { url: '/v1/sys/user/updatePassword' },
};
